import { Member } from './Member';
import { BaseView } from './BaseView';
import { registerSchema } from './transform';
import type { IMediaItem } from './Media';

export class Comment {
  Id: number = 0;
  Text: string = '';
  DateCreated: Date = new Date();

  Member: Member = new Member();

  LikesCount: number = 0;
  IsAuthor: boolean = false;
  CanDelete: boolean = false;
  /** Viewer is staff and not the author: may delete the comment (website only in the UI). */
  CanModerate: boolean = false;
  IsLiked: boolean = false;
  Media?: IMediaItem | null = null;

  get HasText(): boolean {
    return this.Text?.length > 0;
  }

  get HasMedia(): boolean {
    return !!this.Media;
  }

  get IsEdited(): boolean {
    return this.Text?.endsWith('(Edited)');
  }

  get TextHtmlNotEdited(): string {
    let searchString = '(Edited)';
    let text = this.IsEdited ? this.Text.slice(0, -searchString.length) : this.Text;

    // Only wrap in <p> tag if it's not already wrapped
    if (text && !text.trim().startsWith('<p>')) {
      return `<p>${text}</p>`;
    }

    return text;
  }
  
}

export class CommentsView extends BaseView {
  CommentItems: Comment[] = [];
}

registerSchema(Comment, {
  DateCreated: 'date',
  Member: Member,
});

registerSchema(CommentsView, {
  CommentItems: [Comment],
});
